import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { UserStore } from '../stores/user.store';

export const emailConfirmedGuard: CanActivateFn = () => {
  const userStore = inject(UserStore);
  const router = inject(Router);

  if (userStore.isConfirmed()) {
    return true;
  }

  return router.createUrlTree(['/confirm-email']);
};
